/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Music genre
 * @export
 */
export const Genre = {
    Electronic: 'Electronic',
    Rock: 'Rock',
    Metal: 'Metal',
    Alternative: 'Alternative',
    HipHopRap: 'Hip-Hop/Rap',
    Experimental: 'Experimental',
    Punk: 'Punk',
    Folk: 'Folk',
    Pop: 'Pop',
    Ambient: 'Ambient',
    Soundtrack: 'Soundtrack',
    World: 'World',
    Jazz: 'Jazz',
    Acoustic: 'Acoustic',
    Funk: 'Funk',
    RbSoul: 'R&B/Soul',
    Devotional: 'Devotional',
    Classical: 'Classical',
    Reggae: 'Reggae',
    Podcasts: 'Podcasts',
    Country: 'Country',
    SpokenWord: 'Spoken Word',
    Comedy: 'Comedy',
    Blues: 'Blues',
    Kids: 'Kids',
    Audiobooks: 'Audiobooks',
    Latin: 'Latin',
    LoFi: 'Lo-Fi',
    Hyperpop: 'Hyperpop',
    Dancehall: 'Dancehall',
    Techno: 'Techno',
    Trap: 'Trap',
    House: 'House',
    TechHouse: 'Tech House',
    DeepHouse: 'Deep House',
    Disco: 'Disco',
    Electro: 'Electro',
    Jungle: 'Jungle',
    ProgressiveHouse: 'Progressive House',
    Hardstyle: 'Hardstyle',
    GlitchHop: 'Glitch Hop',
    Trance: 'Trance',
    FutureBass: 'Future Bass',
    FutureHouse: 'Future House',
    TropicalHouse: 'Tropical House',
    Downtempo: 'Downtempo',
    DrumBass: 'Drum & Bass',
    Dubstep: 'Dubstep',
    JerseyClub: 'Jersey Club',
    Vaporwave: 'Vaporwave',
    Moombahton: 'Moombahton'
} as const;
export type Genre = typeof Genre[keyof typeof Genre];


export function GenreFromJSON(json: any): Genre {
    return GenreFromJSONTyped(json, false);
}

export function GenreFromJSONTyped(json: any, ignoreDiscriminator: boolean): Genre {
    return json as Genre;
}

export function GenreToJSON(value?: Genre | null): any {
    return value as any;
}

